import { render, staticRenderFns } from "./DevelopersList.vue?vue&type=template&id=137fcfac&scoped=true"
import script from "./DevelopersList.vue?vue&type=script&lang=js"
export * from "./DevelopersList.vue?vue&type=script&lang=js"
import style0 from "./DevelopersList.vue?vue&type=style&index=0&id=137fcfac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137fcfac",
  null
  
)

export default component.exports